<template>
    <tr>
        <!-- <td>{{index + 1 + offset}}</td> -->
        <td>{{index+1}}</td>
        <td>{{rec_status_text}}</td>
        <td v-if="status_type == 1">
            <span style="color:#87D37C;">
                <i class="lnr lnr-checkmark-circle"></i>
            </span>
        </td>
        <td v-else>
            <span style="color:#cc0000;">
                <i class="lnr lnr-cross-circle"></i>
            </span>
        </td>
        <td>{{ogrn}}</td>
        <td style="font-weight: 700;">
            <a v-bind="href" target="_blank">
                {{name_short}}
            </a>
            <monitoring-set-delete-button :ogrn="ogrn"></monitoring-set-delete-button>
        <td>{{date_start}}</td>
        <td>
            <span style="white-space:nowrap;" v-if="inn">ИНН {{inn}}<br></span>
            <span style="white-space:nowrap;" v-if="okpo">ОКПО {{okpo}}<br></span>
            <span style="white-space:nowrap;" v-if="kpp">КПП {{kpp}}<br></span>
        </td>
        <td>
            <div v-if="okved_bool">
                {{okved.code}} – {{okved.descr}}
            </div>
        </td>
        <td>
            <div v-if="rukovod">
                <span v-if="rukovod.position">{{rukovod.position}} </span>
                <span style="font-weight: 700;" v-if="rukovod.name">{{rukovod.name}} </span> 
                <span style="white-space: nowrap;" v-if="rukovod.inn">ИНН {{rukovod.inn}}</span>
            </div>
        </td>
        <td class="last-column">
            <p class="address" style="font-weight: 700;" v-if="address">{{address}}</p>
            <p v-if="phones" style="margin: 10px auto;">
                <span v-for="(e, i) in phones" :key="i" class="contact">{{e}}</span>
            </p>
            <p v-if="emails" style="margin: 10px auto;">
                <span v-for="(e, i) in emails" :key="i" class="contact">{{e}}</span>
            </p>
            <p v-if="sites" style="margin: 10px auto;">
                <a target="_blank" :href="'//'+e" v-for="(e,i) in sites" :key="i">{{e}}</a>
            </p>
        </td>
    </tr>
</template>

<script>
import monitoringSetDeleteButton from './../monitoring/monitoringSetDeleteButton.vue'

export default {
    props: [
        'elementInfo',
        'index'
    ],
    components: {
        "monitoring-set-delete-button": monitoringSetDeleteButton
    },
    computed: {
        status_type(){
            return this.$props.elementInfo.status_type
        },
        offset(){
            return Number(this.$store.state.search.pagination.limit * this.$store.state.search.pagination.page - this.$store.state.search.pagination.limit)
        },
        sites(){
            if(typeof this.$props.elementInfo.sites == 'object' && this.$props.elementInfo.sites.length) {
                return this.$props.elementInfo.sites.filter((e,i) => i < 3)
            }
        },
        phones(){
            if(typeof this.$props.elementInfo.phones == 'object' && this.$props.elementInfo.phones.length) {
                return this.$props.elementInfo.phones.filter((e,i) => i < 3)
            }
        },
        emails(){
            if(typeof this.$props.elementInfo.emails == 'object' && this.$props.elementInfo.emails.length) {
                return this.$props.elementInfo.emails.filter((e,i) => i < 3)
            }
        },
        address(){
            return this.$props.elementInfo.address
        },
        rec_status_text(){
            if(this.$props.elementInfo.rec_type == 1){
                return "ЮЛ"
            } else {
                return "ИП"
            }
        },
        rukovod(){
            return this.$props.elementInfo.stakeholders.filter(e=> e.type == 1)[0]
        },
        ogrn(){
            return this.$props.elementInfo.ogrn
        },
        inn(){
            return this.$props.elementInfo.inn
        },
        okpo(){
            return this.$props.elementInfo.okpo
        },
        kpp(){
            return this.$props.elementInfo.kpp
        },
        okved_bool() {
            if(this.$props.elementInfo.okved && JSON.stringify(this.$props.elementInfo.okved) != '{}' && this.$props.elementInfo.okved.code && this.$props.elementInfo.okved.descr) {
                return true
            } else {
                return false
            }
        },
        okved(){
            return this.$props.elementInfo.okved
        },
        name_full(){
            return this.$props.elementInfo.name_full
        },
        name_short(){
            return this.$props.elementInfo.name_short
        },
        date_stop(){
            return this.$props.elementInfo.date_stop
        },
        date_start(){
            return this.$props.elementInfo.date_start
        },
        status() {
            return !(new Boolean(this.$props.elementInfo.date_stop).valueOf())
        },
        href() {
            if(this.$props.elementInfo.ogrn){
                if(this.$props.elementInfo.ogrn.length == 13){
                    return {
                        ['href']: "/company/" + this.$props.elementInfo.ogrn
                    }
                } else {
                    return {
                        ['href']: "/person/" + this.$props.elementInfo.ogrn
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.contact {
    display: block;
}
tr td {  font-size: 13px; padding: 20px 10px; padding-left: 0; border-bottom: solid 1px rgba(150,150,150,0.1); }
tr:hover { background: #fbf7fd; }
tr.header td { font-weight: 700; }
tr.header:hover { background: #fff; }
td p.address { max-width: 172px; }
</style>
